<script setup>
import { ref, shallowRef, toRaw } from "vue";
import { onHttpError } from "vutil";
import SetPasswd from "./views/SetPasswd.vue";
import Register from "./views/Register.vue";
import Login from "./views/Login.vue";

const view = ref(Login);
const login = shallowRef(null);
let resolve = null;

function auth()
{
	if (!login.value)
		login.value = new Promise((res) => resolve = res);

	return login.value;
}

onHttpError(async (resp, options) =>
{
	if (resp.status === 401) {
		await auth();
		resp = await fetch(resp.url, options);

		if (resp.ok)
			return resp;
	}

	throw new Error((await resp.json()).error);
});
</script>

<template>
	<UiDialog v-if="login" style="width: 400px" modal>
		<component :is="view" @login="login = null; resolve()"/>
		<template v-if="toRaw(view) === Login">
			<p>Har du glemt passordet? <a href="" @click.prevent="view = SetPasswd">Sett nytt passord</a></p>
			<p>Har du ingen konto? <a href="" @click.prevent="view = Register">Registrer deg nå</a></p>
		</template>
		<p v-else><img class="icon-arrow-left" height="14"> <a href="" @click.prevent="view = Login">Logg inn</a></p>
	</UiDialog>
</template>
